import { defineStore } from "pinia";
import { http } from "@/extensions/http";
import API_ENDPOINTS from "@/config/API_ENDPOINTS.ts";

export const useChairStore = defineStore("chair", {
  actions: {
    async get() {
      const { data } = await http.get<Chair>(API_ENDPOINTS.CHAIR.SHOW);

      return data;
    },
  },
});
